export const tableNormalizeColWidths = (widths: number[]): number[] => {
  if (widths.length === 0) return [];
  // Replace invalid entries (undefined/NaN/negative) with 0 so the sum stays
  // finite. If every entry is invalid, fall back to equal widths.
  const sanitized = widths.map((w) => (Number.isFinite(w) && w > 0 ? w : 0));
  const totalSum = sanitized.reduce((sum, value) => sum + value, 0);
  if (totalSum <= 0) {
    const equal = 100 / widths.length;
    return widths.map(() => equal);
  }
  return sanitized.map((width) => (width / totalSum) * 100);
};
